import { Link, useParams } from 'react-router-dom';
import { Stack, Text } from '@repletoryreach/sdk-ui';
import { Alert } from '@repletoryreach/sdk-ui/data-display';
import { useBots } from '../../../lib/bots';
import { BotEditor } from './components/BotEditor';
import { useT } from '../../../i18n/I18nProvider';

/** Settings → Assistant → one chatbot: its editor, where it answers, and what can be done to it. */
export default function SettingsAssistantBotPage() {
  const t = useT();
  const { id } = useParams();
  const { bots, multi, isPending } = useBots();
  const bot = bots.find((b) => b.id === id);

  if (isPending) return <Text role="bodySmall" c="var(--rr-color-text-muted)">{t('common.loading')}</Text>;

  return (
    <Stack gap="lg">
      <Text role="bodySmall"><Link to="/settings/assistant">{t('bots.backToList')}</Link></Text>
      {bot ? <BotEditor key={bot.id} bot={bot} multi={multi} /> : <Alert color="warning">{t('bots.notFound')}</Alert>}
    </Stack>
  );
}
